"use client";

import React from "react";

type TextSize = "medium" | "large";

interface StyledTextProps {
    children: React.ReactNode;
    size?: TextSize;
    className?: string;
}

const sizeClasses: Record<TextSize, string> = {
    medium: "text-[22px] xl:text-[20px] 3xl:text-[25px] 4xl:text-[30px]",
    large: "text-[22px] xl:text-[40px] xl:leading-[46px] 3xl:text-[50px] 3xl:leading-[56px] 4xl:text-[60px] 4xl:leading-[66px]",
};

const shadowClasses: Record<TextSize, string> = {
    medium: "text-shadow-medium-border",
    large: "text-shadow-big-border",
};

export const GoldenText = ({ children, size = "large", className = "" }: StyledTextProps) => {
    const sizeClass = sizeClasses[size];
    const shadowClass = shadowClasses[size];

    return (
        <div className={`relative ${className}`}>
            <div className={`relative z-[2] font-eurostar-extended ${sizeClass} bg-[linear-gradient(180deg,#FFFF8E_0%,#FFFF8E_10%,#CA9008_50%,#FFFF8E_90%,#FFFF8E_100%)] bg-clip-text text-transparent text-shadow-big`}>
                {children}
            </div>
            <div className={`absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] w-full z-[1] font-eurostar-extended ${sizeClass} ${shadowClass} shadow-[#2D1705]`}>
                {children}
            </div>
        </div>
    );
};

export const GrayText = ({ children, size = "large", className = "" }: StyledTextProps) => {
    const sizeClass = sizeClasses[size];
    const shadowClass = size === "medium" ? "text-shadow-medium" : "text-shadow-big";

    return (
        <div className={`relative ${className}`}>
            <div className={`relative z-[2] font-eurostar-extended ${sizeClass} bg-gradient-to-b from-[#a89f9c] via-[#7f7979] via-20% to-white bg-clip-text text-transparent text-shadow-big`}>
                {children}
            </div>
            <div className={`absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] w-full z-[1] font-eurostar-extended ${sizeClass} ${shadowClass} shadow-[#2D1705]`}>
                {children}
            </div>
        </div>
    );
};
